interface Product {
  customizationRequired: boolean;
  customizationUrl: string;
  isCustomizable: boolean;
}

export default ({
  customizationRequired,
  customizationUrl,
  isCustomizable,
}: Product): boolean => {
  return !!(customizationRequired && (customizationUrl || isCustomizable));
};
